<template>
  <f7-block>
    <f7-block-title>{{ $t('groupDashboard.payouts') }}</f7-block-title>
    <div class="metric-grid">
      <div class="metric-card">
        <span class="metric-lbl">{{ $t('groupDashboard.pendingPayouts') }}</span>
        <span class="metric-val">{{ fmt(data.pendingPayouts) }}</span>
      </div>
      <div class="metric-card">
        <f7-icon f7="checkmark_circle_fill" size="18" class="metric-icon color-green" />
        <span class="metric-lbl">{{ $t('groupDashboard.completedPayouts') }}</span>
        <span class="metric-val">{{ fmt(data.completedPayouts) }}</span>
      </div>
      <div class="metric-card">
        <span class="metric-lbl">{{ $t('groupDashboard.totalPayoutAmount') }}</span>
        <span class="metric-val">{{ fmtCfa(data.totalPayoutAmount) }}</span>
      </div>
      <div class="metric-card">
        <span class="metric-lbl">{{ $t('groupDashboard.pendingPayoutAmount') }}</span>
        <span class="metric-val">{{ fmtCfa(data.pendingPayoutAmount) }}</span>
      </div>
      <div class="metric-card bg-green">
        <f7-icon f7="wallet_fill" size="20" class="metric-icon" />
        <span class="metric-lbl">{{ $t('groupDashboard.availableBalance') }}</span>
        <span class="metric-val">{{ fmtCfa(data.availableBalance) }}</span>
      </div>
    </div>
  </f7-block>
</template>
<script setup>
const props = defineProps({ data: { type: Object, required: true } });
function fmt(n) { return n != null ? Math.round(n).toLocaleString('fr-FR') : '-'; }
function fmtCfa(v) { if (v == null) return '-'; const n = parseFloat(v) || 0; return n.toLocaleString('fr-FR', {maximumFractionDigits:0}) + ' FCFA'; }
</script>
<style scoped>
.metric-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(150px, 1fr)); gap: 10px; }
.metric-card { display:flex; flex-direction:column; align-items:center; gap:4px; padding:14px 8px; border-radius:12px; background:var(--f7-list-bg-color,#f5f5f5); }
.metric-card.bg-green { background: color-mix(in srgb, #4caf50 8%, var(--f7-list-bg-color,#f5f5f5)); }
.metric-icon { margin-bottom:2px; }
.metric-lbl { font-size:11px; color:var(--f7-on-surface-variant,#8e8e93); text-align:center; line-height:1.3; }
.metric-val { font-size:18px; font-weight:700; color:var(--f7-text-color,#333); }
.bg-green .metric-val { color: #2e7d32; }
</style>